import { render, staticRenderFns } from "./AttributesModal.vue?vue&type=template&id=5d8d7912&scoped=true"
import script from "./AttributesModal.vue?vue&type=script&lang=js"
export * from "./AttributesModal.vue?vue&type=script&lang=js"
import style0 from "./AttributesModal.vue?vue&type=style&index=0&id=5d8d7912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8d7912",
  null
  
)

export default component.exports